import { BaseService } from './BaseService';

export class RecipeService extends BaseService {
  async getFilters(param?: any): Promise<any> {
    return this.get('/api/v1/filters', param);
  }
  async getCuisines(param?: any): Promise<any> {
    return this.get('/api/v1/cuisines', param);
  }
  async getMeals(param?: any): Promise<any> {
    return this.get('/api/v1/meal_times', param);
  }
  async getMealCourses(param?: any): Promise<any> {
    return this.get('/api/v1/meal_courses', param);
  }
  async searchRecipes(param?: any): Promise<any> {
    return this.get(`/api/v1/recipes/search`, param);
  }
  async searchRecipesByIngredients(param?: any): Promise<any> {
    return this.get(`/api/v1/ingredients/recipes`, param);
  }
  async getPrimaryIngredients(): Promise<any> {
    return this.get(`/api/v1/ingredients/primary_ingredients`);
  }
  async getIngredientsByQuery(param?: any): Promise<any> {
    return this.get(`/api/v1/ingredients/search`, param);
  }
  async getRecipeById(id: number | string): Promise<any> {
    return this.get(`/api/v1/recipes/${id}`);
  }
  async likeDislikeRecipe(recipeId: number | string, param?: any): Promise<any> {
    return this.post(`api/v1/recipes/${recipeId}/admire`, param);
  }
  async getRecipeActivities(recipeId: number | string): Promise<any> {
    return this.get(`api/v1/recipes/${recipeId}/user_activity`);
  }
  async updateRecipeMadeStatus(recipeId: number | string, param?: any): Promise<any> {
    return this.post(`api/v1/recipes/${recipeId}/completed`, param);
  }
  async getRelatedRecipes(recipeId: number | string): Promise<any> {
    return this.get(`api/v1/recipes/${recipeId}/related_recipes`);
  }
  async getRecipeTips(recipeId: number | string, param?: any): Promise<any> {
    return this.get(`api/v1/recipes/${recipeId}/tips`, param);
  }
  async getRecipeIngredients(recipeId: number | string): Promise<any> {
    return this.get(`api/v1/recipes/${recipeId}/recipes_ingredients`);
  }
  async getCookingInstructions(recipeId: number | string): Promise<any> {
    return this.get(`api/v1/recipes/${recipeId}/cooking_instructions`);
  }
  async createTip(recipeId: number | string, param?: any): Promise<any> {
    return this.post(`api/v1/recipes/${recipeId}/tips`, param);
  }
  async reactToTip(recipeId: number | string, tipId: number | string, param?: any): Promise<any> {
    return this.post(
      `api/v1/recipes/${recipeId}/tips/${tipId}/react_to_tip`,
      param
    );
  }
}

export default new RecipeService();
